<template>
    <div class="wrapper" ref="summary" v-focus>
        <div class="summary" v-if="haveMessages">
            <div v-for="message in appMessages" v-bind:key="message.id">
                <img
                    v-if="message.severity === 'i'"
                    v-bind:src="informationImage"
                    alt="Success!!"
                />
                <img
                    v-if="message.severity === 'w'"
                    v-bind:src="warningImage"
                    alt="Warning!!"
                />
                <img
                    v-if="message.severity === 'e'"
                    v-bind:src="errorImage"
                    alt="Error!!"
                />
                <span v-html="message.text"></span>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint no-mixed-spaces-and-tabs: 'off', no-tabs: 'off' */
import { mapGetters, mapState } from 'vuex';
import Events from '@/bo/Events.js';
import informationImage from '@/assets/icons-success-40.gif';
import warningImage from '@/assets/icons-error-35.gif';
import errorImage from '@/assets/icons-alert-35.gif';

function scrollIntoView(vm, messages) {
    if (
        messages &&
        messages.length > 0 &&
        vm.$refs.summary &&
        vm.$refs.summary.scrollIntoView
    )
        vm.$refs.summary.scrollIntoView();
}
export default {
    props: [],
    //inject: ['emitter'],
    computed: {
        ...mapState({
            appMessages: (state) => state.display.appMessages,
            haveMessages: (state) => state.display.haveMessages
        }),
        ...mapGetters({})
    },
    watch: {
        appMessages(value) {
            scrollIntoView(this, value);
        }
    },
    created: function () {
        const vm = this;
        vm.myEvents = new Events();
        scrollIntoView(vm, vm.appMessages);
        vm.myEvents.on('hasMessages', () => {
            scrollIntoView(vm, vm.appMessages);
        });
    },
    beforeUnmount() {
        this.myEvents = Events.kill(this.myEvents);
    },
    data: function () {
        let vm = this;
        return {
            myEvents: null,
            id: null,
            theMessages: [],
            informationImage,
            warningImage,
            errorImage,
            imagePath: '',
            imageCaption: ''
        };
    },
    mounted() {
        const vm = this;
        this.id = 'validationSummary_' + this._uid;
    }
};
</script>

<style scoped>
.summary {
    width: 90;
    display: block;
    border: 1px solid rgb(229, 229, 229);
    margin-bottom: 20px;

    display: flex;
    /* justify-content: space-evenly; */
    flex-wrap: wrap;
    padding: 7px 0 7px 20px;
}

.summary > div {
    padding: 3px 0px 3px 0px;
    /* display: block; */
    width: 100%;
}
img {
    width: 26px;
    height: 26px;
    flex-direction: column;
}
span {
    width: 80%;
    flex-direction: column;
    padding-left: 5px;
    vertical-align: top;
}
</style>
